import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    
    const validateToken = async () => {
      if (token && savedUser) {
        try {
          // Configurar el token en los headers
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          
          // Verificar si el token es válido haciendo una petición al backend
          await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/validate`);
          
          // Si la petición es exitosa, el token es válido
          setUser(JSON.parse(savedUser));
        } catch (error) {
          console.error('Token validation error:', error);
          // Si hay un error, el token no es válido o ha expirado
          logout();
        }
      }
      setLoading(false);
    };
    
    validateToken();
  }, []);

  const login = async (credential) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/google`, { credential });
      const { token, user } = response.data;
      
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      setUser(user);
      return true;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };
  
  // Función para verificar si el usuario está autenticado antes de cada petición
  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      return false;
    }
    
    try {
      await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/validate`);
      return true;
    } catch (error) {
      console.error('Authentication check failed:', error);
      logout();
      return false;
    }
  };

  const value = {
    user,
    isAuthenticated: !!user,
    login,
    logout,
    loading,
    checkAuth
  };

  if (loading) {
    return <div>Cargando...</div>;
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};